import React from 'react';
import { observer } from 'mobx-react-lite';
import { ReactComponent as PlusIcon } from 'components/icons/plus-circle.svg';
import { useInjection } from 'services/ioc/ioc.react';
import { TaggingStore } from 'stores/Tagging/TaggingStore';
import { ServiceTypes } from 'constants/ServiceTypes';
import { AddPlayMenuWrapper, Divider, ItemText, MenuItem, MenuItems, MenuItemsOuter } from './AddPlayMenuStyles';

export const AddPlayMenu: React.FC = observer(() => {
  const taggingStore = useInjection<TaggingStore>(ServiceTypes.TaggingStore);
  const { playStore } = taggingStore;
  const onClickAddOnTop = () => {
    playStore.createManualPlayOnTopOfTheList();
  };

  const onClickAddBeforeSelected = () => {
    if (playStore.selectedPlay) {
      playStore.createManualPlayBeforeSelected();
    }
  };

  const onClickAddAfterSelected = () => {
    if (playStore.selectedPlay) {
      playStore.createManualPlayAfterSelected();
    }
  };

  const areUnsavedChanges = () => {
    return playStore.selectedPlay && playStore.selectedPlay.isChanged && !playStore.selectedPlay.isPlaceholder;
  };

  return (
    <AddPlayMenuWrapper className={`${areUnsavedChanges() ? 'disabled' : ''}`}>
      <PlusIcon />
      <MenuItemsOuter className='menu-items-outer'>
        <MenuItems>
          <MenuItem onClick={onClickAddOnTop} data-test='add-play-at-top'>
            <ItemText>Add play at top</ItemText>
          </MenuItem>
          <Divider />
          <MenuItem
            className={` ${playStore.selectedPlay ? '' : 'disabled'}`}
            onClick={onClickAddBeforeSelected}
            data-test='add-play-before-selection'
          >
            <ItemText>Add play before selection</ItemText>
          </MenuItem>
          <Divider />
          <MenuItem
            className={` ${playStore.selectedPlay ? '' : 'disabled'}`}
            onClick={onClickAddAfterSelected}
            data-test='add-play-after-selection'
          >
            <ItemText>Add play after selection</ItemText>
          </MenuItem>
        </MenuItems>
      </MenuItemsOuter>
    </AddPlayMenuWrapper>
  );
});
